<script>
import DropDown from '../reUse/DropDown.vue';
import Zapisi from "./Motorna_beri.vue";
import Notification from "../reUse/Notification.vue";
import {i18n} from '@/i18n'
import sl from '@/Prevodi/Motorna-sl.json';
import en from '@/Prevodi/Motorna-en.json';
import it from '@/Prevodi/Motorna-it.json';
import {config} from "@/config";

export default {
  components: {
    DropDown,
    Zapisi,
    Notification
  },
  emits: ['odjava'],
  data() {
    return {
      prevodi: false,
      datum: new Date().toISOString().split('T')[0],
      datumO: new Date().toISOString().split('T')[0],
      datumD: new Date().toISOString().split('T')[0],
      pilotName: '',
      instructorName: '',
      regLetala: '',
      krajVzleta: 'LJAJ',
      krajPristanka: 'LJAJ',
      poletanje: '',
      casVziga: '', //nepomembno
      pristanek: '',
      casUgasanja: '', //nepomembno
      opomba: '',
      IzbranNamen: '',
      IzbranaNaloga: '',
      dPilot: false,
      dLetalo: false,
      dInstruktor: false,
      dFiltri: false,
      dNamen: false,
      dNaloga: false,
      dPristanek: false,
      dVzlet: false,
      Letala: [],
      Piloti: [],
      Instruktor: [],
      Letalisca: [],
      stPristankov: 1,
      stanjeStevca: '',
      v_zraku: '',
      nezakljucen: false,
      vnosTrajanja: false,
      flightTime: false,
      takeoff: '',
      landing: '',
      namen: [
        {id: 0, namen: 'Trenažni let'},
        {id: 1, namen: 'Kontrolni let'},
        {id: 2, namen: 'Osnovno šolanje'},
        {id: 3, namen: 'Šolanje za poob.'},
        {id: 4, namen: 'Tekmovalni let'},
        {id: 5, namen: 'Izpitni let'},
        {id: 6, namen: 'Preizkusni let'},
        {id: 7, namen: 'Uvodni let'},
        {id: 8, namen: 'Protipožarni let'},
        {id: 9, namen: 'AK'},
        {id: 10, namen: 'DRUGO'},
      ],
      naloga: [
        {id: 0, naloga: 'Šolski krog'},
        {id: 1, naloga: 'Let v rajonu'},
        {id: 2, naloga: 'Prelet'},
        {id: 3, naloga: 'Ruta'},
      ],
      prikaz: 'vnos',
      PodatkiObracun: [],
      PodatkiNezakljuceni: [],
      dodajanjeLetalisca: false,
      letalisceDodano: false,
      imeDodanegaLetalisca: null,
      novIcao: '',
      //NOTIFICATION
      ShowNoti: false,
      text: '',
      types: '',
      user: config.FullUser,
      vnasam: false
    }
  },
  watch: {
    pristanek(nov, star) {
      if (this.poletanje !== '' && nov !== '') {
        this.v_zraku = this.casLetenja(nov, this.poletanje);
      }
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetLetala();
    this.GetPiloti();
    this.GetLetalisca();
    this.GetPodatkiObracuna();
    this.WriteLocal();
  },
  computed: {
    imeUpper: {
      get() {
        return this.novIcao;
      },
      set(value) {
        this.novIcao = value.toUpperCase();
      }
    }
  },
  methods: {
    WriteLocal() {
      const now = new Date().toISOString().split('T')[0];
      if (localStorage.getItem("DatumM") === now) {
        if (localStorage.getItem("PilotNameM") !== null)
          this.pilotName = localStorage.getItem("PilotNameM");
        if (localStorage.getItem("InstructorNameM") !== null)
          this.instructorName = localStorage.getItem("InstructorNameM");
        if (localStorage.getItem("RegLetalaM") !== null)
          this.regLetala = localStorage.getItem("RegLetalaM");
        if (localStorage.getItem("FlightTime") !== null)
          this.flightTime = Boolean(JSON.parse(localStorage.getItem("FlightTime")));
        if (localStorage.getItem("NamenM") !== null)
          this.IzbranNamen = localStorage.getItem("NamenM");
        if (localStorage.getItem("NalogaM") !== null)
          this.IzbranaNaloga = localStorage.getItem("NalogaM");
        if (localStorage.getItem("KrajVzletaM") === null || localStorage.getItem("KrajVzletaM") === '') {
          this.krajVzleta = 'LJAJ';
        } else {
          this.krajVzleta = localStorage.getItem("KrajVzletaM");
        }
        if (localStorage.getItem("KrajPristankaM") === null || localStorage.getItem("KrajPristankaM") === '') {
          this.krajPristanka = 'LJAJ';
        } else {
          this.krajPristanka = localStorage.getItem("KrajPristankaM");
        }
      } else {
        localStorage.removeItem("PilotNameM");
        localStorage.removeItem("InstructorNameM");
        localStorage.removeItem("RegLetalaM");
        localStorage.removeItem("FlightTime");
        localStorage.removeItem("NamenM");
        localStorage.removeItem("NalogaM");
        localStorage.removeItem("KrajVzletaM");
        localStorage.removeItem("KrajPristankaM");
      }
    },
    CreatingLocal() {
      localStorage.setItem("DatumM", new Date().toISOString().split('T')[0]);
      localStorage.setItem("PilotNameM", this.pilotName);
      localStorage.setItem("InstructorNameM", this.instructorName);
      localStorage.setItem("RegLetalaM", this.regLetala);
      localStorage.setItem("FlightTime", JSON.stringify(this.flightTime));
      localStorage.setItem("NamenM", this.IzbranNamen);
      localStorage.setItem("NalogaM", this.IzbranaNaloga);
      if (localStorage.getItem("KrajVzletaM") === '' || localStorage.getItem("KrajVzleta") === null) {
        localStorage.setItem("KrajVzletaM", 'LJAJ');
      } else {
        localStorage.setItem("KrajVzletaM", this.krajVzleta);
      }
      if (localStorage.getItem("KrajPristankaM") === '' || localStorage.getItem("KrajPristanka") === null) {
        localStorage.setItem("KrajPristankaM", 'LJAJ');
      } else {
        localStorage.setItem("KrajPristankaM", this.krajPristanka);
      }
    },
    PosodobiLocal() {
      setTimeout(() => {
        this.CreatingLocal();
      }, 500);
    },
    GetLetalisca() {
      let app = this;
      axios
          .get("./api/sifranti/letalisca/beri/")
          .then(function (response) {
            app.Letalisca = response.data;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            for (let i = 0; i < response.data.letala.length; i++) {
              if (response.data.letala[i].vrsta_letala === 'Motorno') {
                app.Letala.push(response.data.letala[i]);
              }
            }
            // app.Letala = response.data;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPiloti() {
      let app = this;
      axios
          .get("./api/sifranti/piloti/izpis/")
          .then(function (response) {
            if (app.user.lvl < 4) {
              app.Piloti.piloti = response.data.piloti.filter(pilot => pilot.datum_izbrisa == null);
            } else {
              app.Piloti.piloti = response.data.piloti.filter(pilot => pilot.email === app.user.email);
            }

            app.Instruktor = response.data.piloti.filter(pilot => pilot.instruktor === true && pilot.datum_izbrisa == null);
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPodatkiObracuna() {
      let app = this;
      let podatki = new URLSearchParams();
      podatki.append("datumZ", this.datumO);
      podatki.append("datumK", this.datumD);
      var Ddatum = new Date().toISOString().split('T')[0];
      if (this.datumO !== Ddatum && this.user.lvl === 3) { //če je uporabnik kronometrist in bi rad gledal lete za nazaj prikažemo samo njegove lete
        podatki.append("posamezno", true);
      }
      if (this.user.lvl > 3) { //če je uporabnik "pilot", prikažemo samo današnje lete, drugače vse
        podatki.append("posamezno", true);
      }
      axios
          .post("./api/log/motorno/izpis/", podatki)
          .then(function (response) {
            app.PodatkiObracun = response.data.podatki;
            app.GetPodatkiNezakljucenih();
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPodatkiNezakljucenih() {
      let podatki = new URLSearchParams();
      podatki.append("datumZ", this.datum);
      podatki.append("datumK", this.datum);
      axios
          .post("./api/log/motorno/izpis/nezakljuceni/", podatki)
          .then((response) => {
            this.PodatkiNezakljuceni = response.data.podatki;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    SetDatumO(datum) {
      this.datumO = datum;
    },
    setDatumD(datum) {
      this.datumD = datum;
    },
    Add() {
      if (this.datum !== '' && this.pilotName !== '' && this.regLetala !== '' && this.IzbranNamen !== '' && this.IzbranaNaloga !== '' && this.krajVzleta !== '' && this.krajPristanka !== '' && this.poletanje !== '') {
        this.vnasam = true;
        let app = this;
        let dodaj = new URLSearchParams();
        const datumDanes = new Date().toISOString().split('T')[0];
        if (app.datum > datumDanes) {
          this.vnasam = false;
          // alert("Zapis ima izbran datum v prihodnosti, POPRAVI izbran datum!");
          app.text = app.$t('obvestila.zapisPrihodnost');
          app.types = "Napaka";
          this.ErrorReport('napaka-motorna-vnos', '/api/log/motorno/vnos/', 'Add()', 'Motorna-vnos-dodajanje-leta', 'Datum zapisa je v prihodnosti');
          app.ShowNoti = true;
          return;
        } else {
          if (this.nezakljucen === false) {
            if (app.datum === datumDanes) {
              //preverjanje časa, da ni v prihodnosti
              let cas = new Date();
              cas.setHours(cas.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
              cas.setMinutes(cas.getMinutes() + 15); //dovolimo 15 minut v prihodnost
              cas = cas.toISOString().split('T')[1].split('.')[0];
              let casP = new Date();
              casP.setHours(casP.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
              casP = casP.toISOString().split('T')[1].split('.')[0];
              if (this.poletanje > casP || this.pristanek > cas) {
                this.vnasam = false;
                // alert("Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!");
                app.text = app.$t('obvestila.zapisCasPrihodnost');
                app.types = "Napaka";
                app.ShowNoti = true;
                this.ErrorReport('napaka-motorna-vnos', '/api/log/motorno/vnos/', 'Add()', 'Motorna-vnos-dodajanje-leta', 'Čas poletanja je v prihodnosti');
                return;
              }
            }
            if (this.pristanek <= this.poletanje) {
              this.vnasam = false;
              this.text = this.$t('obvestila.zapisCasNapaka');
              this.types = "Napaka";
              this.ShowNoti = true;
              this.ErrorReport('napaka-motorna-vnos', '/api/log/motorno/vnos/', 'Add()', 'Motorna-vnos-dodajanje-leta', 'Čas pristanka je pred časom poleta');
              return;
            }
            if (this.flightTime) {
              if (this.takeoff === '' || this.landing === '') {
                let requiredPolja = ['takeoff', 'landing'];
                this.CheckInputs(requiredPolja);
                this.vnasam = false;
                // alert('Napaka pri vnosu, preglej če imaš izpolnjena vsa polja!');
                this.text = this.$t('obvestila.napakaVnosa');
                this.types = "Napaka";
                this.ShowNoti = true;
                this.ErrorReport('napaka-motorna-vnos', '/api/log/motorno/vnos/', 'Add()', 'Motorna-vnos-dodajanje-leta', 'Uporabnik ni izpolnil vseh polj');
              }
              if (this.pristanek < this.landing || this.poletanje > this.takeoff) {
                this.vnasam = false;
                this.text = this.$t('obvestila.zapisFlightcasi');
                this.types = "Napaka";
                this.ShowNoti = true;
                this.ErrorReport('napaka-motorna-vnos', '/api/log/motorno/vnos/', 'Add()', 'Motorna-vnos-dodajanje-leta', 'Čas pristanka je pred časom poleta');
                return;
              }
            }
          }
          dodaj.append('datum', app.datum);
          dodaj.append('pilot', app.pilotName);
          dodaj.append('instruktor', app.instructorName);
          dodaj.append('reg_letala', app.regLetala);
          dodaj.append('namen', app.IzbranNamen);
          dodaj.append('naloga', app.IzbranaNaloga);
          dodaj.append('kraj_vzleta', app.krajVzleta);
          dodaj.append('kraj_pristanka', app.krajPristanka);
          dodaj.append('poletanje', app.poletanje);
          // dodaj.append('cas_vziga', app.casVziga);
          dodaj.append('pristanek', app.pristanek);
          // dodaj.append('cas_ugasanja', app.casUgasanja);
          dodaj.append('opomba', app.opomba);
          dodaj.append('st_pristankov', app.stPristankov);
          dodaj.append('stanje_stevca', app.stanjeStevca);
          if (this.flightTime) {
            dodaj.append('vzlet_flight', app.takeoff);
            dodaj.append('pristanek_flight', app.landing);
          }
          if (this.vnosTrajanja) {
            dodaj.append('cas_leta_servis', app.v_zraku);
          } else {
            dodaj.append('cas_leta_servis', '');
          }
          axios
              .post("./api/log/motorno/vnos/", dodaj, {withCredentials: true})
              .then(function (response) {
                app.vnasam = false;
                // alert("Zapis uspešno dodan!");
                app.text = app.$t('obvestila.zapisDodan');
                app.types = "Uspešno";
                app.ShowNoti = true;
                // app.datum = new Date().toISOString().split('T')[0];
                // app.pilotName = '';
                // app.instructorName = '';
                // app.regLetala = '';
                // app.IzbranNamen = '';
                // app.IzbranaNaloga = '';
                app.krajVzleta = 'LJAJ';
                app.krajPristanka = 'LJAJ';
                app.poletanje = '';
                app.takeoff = '';
                // app.casVziga = '';
                app.pristanek = '';
                app.landing = '';
                // app.casUgasanja = '';
                app.opomba = '';
                app.stPristankov = 1;
                app.nezakljucen = false;
                app.stanjeStevca = '';
                app.v_zraku = '';
                app.GetPodatkiObracuna();
                var requiredPolja = ['datum', 'pilotName', 'regLetala', 'IzbranNamen', 'IzbranaNaloga', 'krajVzleta', 'krajPristanka', 'poletanje'];
                if (this.flightTime) {
                  requiredPolja.push('takeoff');
                  requiredPolja.push('landing'); //TODO
                }
                app.ResetRequired(requiredPolja);
              })
              .catch((napaka) => {
                this.vnasam = false;
                if (napaka.response.status === 401) {
                  this.$router.push('/Logout');
                }
                if (napaka.response.data.napaka !== undefined) {
                  this.text = this.$t('obvestila.napakaPosodabljanja');
                } else {
                  this.text = this.$t('obvestila.napakaPosodabljanja');
                }
                this.types = 'Napaka';
                this.ShowNoti = true;
                this.ErrorReport('napaka-motorna-vnos', '/api/log/motorno/vnos/', 'Add()', 'Motorna-vnos-dodajanje-leta', this.text);
              })
        }
      } else {
        var requiredPolja = ['datum', 'pilotName', 'regLetala', 'IzbranNamen', 'IzbranaNaloga', 'krajVzleta', 'krajPristanka', 'poletanje'];
        this.CheckInputs(requiredPolja);
        // alert('Napaka pri vnosu, preglej če imaš izpolnjena vsa polja!');
        this.text = this.$t('obvestila.napakaVnosa');
        this.types = "Napaka";
        this.ShowNoti = true;
        this.ErrorReport('napaka-motorna-vnos', '/api/log/motorno/vnos/', 'Add()', 'Motorna-vnos-dodajanje-leta', 'Uporabnik ni izpolnil vseh polj');
      }

    },
    CheckInputs(inputsArray) {
      //funkcija, ki preveri "obvezne" inpute in jih obarva rdeče, če niso nastavljeni
      for (var i = 0; i < inputsArray.length; i++) {
        if (this[inputsArray[i]] === '') {
          // console.log(inputsArray[i]); //samo za dev
          $('#' + inputsArray[i]).addClass('required-field');
        } else {
          $('#' + inputsArray[i]).removeClass('required-field');
        }
      }
    },
    ResetRequired(inputsArray) {
      for (var i = 0; i < inputsArray.length; i++) {
        $('#' + inputsArray[i]).removeClass('required-field');
      }
    },
    selectPilot(id) {
      let pilot = this.Piloti.piloti.find(p => p.id === id);
      if (pilot) {
        // this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.pilotName = pilot.sifra;
        this.dPilot = false;
        this.CreatingLocal();
      }
    },
    selectInstructor(id) {
      let instruktor = this.Instruktor.find(ins => ins.id === id);
      if (instruktor) {
        this.instructorName = instruktor.ime + ' ' + instruktor.priimek;
        this.dInstruktor = false;
        this.CreatingLocal();
      }
    },
    selectLetalo(id) {
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        if (!letalo.plovnost) {
          this.text = `Izbrali ste letalo katerega je upravitelj označil kot \'neplovno\'. Opomba: ${letalo.plovnost_opomba !== null ? letalo.plovnost_opomba : '/'}`;
          this.types = 'Napaka';
          this.ShowNoti = true;
        }
        this.flightTime = letalo.flight_time;
        this.regLetala = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
        this.PosodobiLocal();
      }
    },
    selectNamen(id) {
      let namen = this.namen.find(n => n.id === id);
      if (namen) {
        this.dNamen = false;
        this.IzbranNamen = namen.namen;
        this.CreatingLocal();
      }
    },
    selectNaloga(id) {
      let naloga = this.naloga.find(na => na.id === id);
      if (naloga) {
        this.dNaloga = false;
        this.IzbranaNaloga = naloga.naloga;
        if (this.IzbranaNaloga === 'Šolski krog') {
          this.nezakljucen = false;
          // this.stPristankov = 1;
          // this.pristanek = '';
        }
        this.CreatingLocal();
      }
    },
    selectPristanek(id) {
      let pristanek = this.Letalisca.letalisca.find(pr => pr.id === id);
      if (pristanek) {
        this.dPristanek = false;
        this.krajPristanka = pristanek.icao;
      }
    },
    selectVzlet(id) {
      let vzlet = this.Letalisca.letalisca.find(vl => vl.id === id);
      if (vzlet) {
        this.dVzlet = false;
        this.krajVzleta = vzlet.icao;
      }
    },
    OpenPilot() {
      this.dPilot = !this.dPilot;
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    OpenInstructor() {
      this.dInstruktor = !this.dInstruktor;
    },
    OpenNamen() {
      this.dNamen = !this.dNamen;
    },
    OpenNaloga() {
      this.dNaloga = !this.dNaloga;
    },
    OpenVzlet() {
      this.dVzlet = !this.dVzlet;
    },
    OpenPristanek() {
      this.dPristanek = !this.dPristanek;
    },
    SpremeniPodatke() {
      this.pristanek = '';
      this.landing = '';
      this.stPristankov = 1;
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
    ErrorReport(imeEventa, endpoint = null, metoda = null, imeNapake = null, opisNapake = null) {
      window.umami.track(imeEventa, {
        endpoint: endpoint,
        metoda: metoda,
        akcija: imeNapake,
        opis: opisNapake
      });
    },
    casLetenja(t1, t2) {
      const vMinute = (time) => {
        const [h, m] = time.split(":").map(Number);
        return h * 60 + m;
      };
      let razlika = vMinute(t1) - vMinute(t2);

      const ure = Math.floor(razlika / 60);
      const minute = razlika % 60;

      return `${ure.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
    },
    DodajLetalisce() {
      $(this.$refs.modalDodajanjaLetalisca).modal('show');
      setTimeout(() => {
        $('#novIcao').focus();
      }, 200);
    },
    ZapriModal() {
      this.dodajanjeLetalisca = false;
      $(this.$refs.modalDodajanjaLetalisca).modal('hide');
    },
    PreveriIcao() {
      this.dodajanjeLetalisca = true;
      if (this.Letalisca.letalisca.some(letalisce => letalisce.icao === this.novIcao)) {
        this.text = 'Letališče že obstaja v naši bazi podatkov';
        this.ShowNoti = true;
        this.types = 'Napaka';
        this.dodajanjeLetalisca = false;
      } else {
        var podatki = new URLSearchParams();
        podatki.append('icao', this.novIcao);
        axios.post('./api/letalisca/', podatki).then((response) => {
          if (response.data.podatki.statusCode === 404) {
            this.text = this.$t('obvestila.letalisceNiNajdeno');
            this.ShowNoti = true;
            this.types = "Napaka";
            this.dodajanjeLetalisca = false;
            return;
          }
          if (response.data.podatki) {
            var ime_letalisca = response.data.podatki.name;
            this.imeDodanegaLetalisca = ime_letalisca;
            var vnos = new URLSearchParams();
            vnos.append('icao', this.novIcao);
            vnos.append('naziv', ime_letalisca);
            axios.post('./api/urednik/letalisca/dodaj/', vnos).then((response) => {
              this.GetLetalisca();
              this.text = this.$t('obvestila.zapisDodan');
              this.ShowNoti = true;
              this.types = "Uspešno";
              this.dodajanjeLetalisca = false;
              this.letalisceDodano = true;
              setTimeout(() => {
                this.letalisceDodano = false;
                this.novIcao = '';
                $('#novIcao').focus();
              }, 3500);
            }).catch((napaka) => {
              if (napaka.response.data.napaka !== undefined) {
                this.text = this.$t('obvestila.napakaDodajanjaLetalisca');
              } else {
                this.text = this.$t('obvestila.napakaDodajanjaLetalisca');
              }
              this.ShowNoti = true;
              this.types = "Napaka";
              this.dodajanjeLetalisca = false;
            });
          }
        }).catch((napaka) => {
          this.text = this.$t('obvestila.napakaDodajanjaLetalisca');
          this.ShowNoti = true;
          this.types = "Napaka";
          this.dodajanjeLetalisca = false;
        });
      }
    }
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{ $t('main.nazaj') }}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{ $t('main.title') }}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'vnos'}" @click="prikaz = 'vnos'"
                    data-umami-event="Motorna-vnos">
              <i class="fas fa-edit"></i>
              <span>{{ $t('nav.vnos') }}</span>
            </button>
            <button class="nav-tab" :class="{'active bg-rdeca': prikaz === 'zapisi'}" @click="prikaz = 'zapisi'"
                    data-umami-event="Motorna-zapisi">
              <i class="fas fa-list"></i>
              <span>{{ $t('nav.zapisi') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <zapisi
      v-show="this.prikaz === 'zapisi'"
      :PodatkiNezakljuceni="this.PodatkiNezakljuceni"
      :PodatkiObracun="this.PodatkiObracun"
      @datumo='SetDatumO'
      @datumk='setDatumD'
      @osvezi="GetPodatkiObracuna()"
      :user="this.user"
  />
  <div class="container p-2" v-show="this.prikaz === 'vnos' && prevodi">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false"/>
    </Transition>
    <div class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6" for="datum">{{ $t('labelsM.datum') }}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datum" required/>
      </div>
    </div>
    <div class="col-12">
      <!-- PILOT -->
      <div class="container">
        <label class="label-dropdown" for="pilotName">{{ $t('labelsM.pilot') }}
          <button v-if="pilotName !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="pilotName = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenPilot()">
          <i v-show="!dPilot" class="fas fa-chevron-right"></i>
          <i v-show="dPilot" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="pilotName" @click.prevent="OpenPilot">
          {{ pilotName }}
        </button>
        <transition name="fade">
          <drop-down @pilot="selectPilot" :data="Piloti" type="piloti" class="drop-down-btn" v-if="dPilot"/>
        </transition>
      </div>
    </div>
    <div class="col-12">
      <!-- INSTRUKTOR -->
      <div class="container">
        <label class="label-dropdown" for="instructorName">{{ $t('labelsM.instruktor') }}
          <button v-if="instructorName !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="instructorName = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenInstructor()">
          <i v-show="!dInstruktor" class="fas fa-chevron-right"></i>
          <i v-show="dInstruktor" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="instructorName"
                @click.prevent="OpenInstructor">{{ instructorName }}
        </button>
        <transition name="fade">
          <drop-down @instruktor="selectInstructor" :data="Instruktor" type="instruktor" class="drop-down-btn"
                     v-if="dInstruktor"/>
        </transition>
      </div>
    </div>
    <div class="col-12">
      <!-- REGISTRACIJA -->
      <div class="container">
        <label class="label-dropdown" for="regLetala">{{ $t('labelsM.reg') }}
          <button v-if="regLetala !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="regLetala = '', flightTime = false, PosodobiLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
          <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
          <i v-show="dLetalo" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenLetalo">
          {{ regLetala }}
        </button>
        <transition name="fade">
          <drop-down @letalo="selectLetalo" :data="Letala" type="letalo" class="drop-down-btn" v-if="dLetalo"/>
        </transition>
      </div>
    </div>
    <div class="col-12">
      <!-- NAMEN -->
      <div class="container">
        <label class="label-dropdown" for="namen">{{ $t('labelsM.namen') }}
          <button v-if="IzbranNamen !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="IzbranNamen = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenNamen()">
          <i v-show="!dNamen" class="fas fa-chevron-right"></i>
          <i v-show="dNamen" class="fas fa-chevron-down"></i>
        </div>
        <button id='IzbranNamen' class="input border-0 rounded-4 p-2 fs-5" type="text" @click.prevent="OpenNamen">
          {{ IzbranNamen }}
        </button>
        <transition name="fade">
          <drop-down @namen="selectNamen" :data="namen" type="namen" class="drop-down-btn" v-if="dNamen"/>
        </transition>
      </div>
    </div>
    <div class="col-12">
      <!-- NALOGA -->
      <div class="container">
        <label class="label-dropdown" for="namen">{{ $t('labelsM.naloga') }}
          <button v-if="IzbranaNaloga !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="IzbranaNaloga = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenNaloga()">
          <i v-show="!dNaloga" class="fas fa-chevron-right"></i>
          <i v-show="dNaloga" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="IzbranaNaloga" @click.prevent="OpenNaloga">
          {{ IzbranaNaloga }}
        </button>
        <transition name="fade">
          <drop-down @naloga="selectNaloga" :data="naloga" type="naloga" class="drop-down-btn" v-if="dNaloga"/>
        </transition>
        <div class='text-danger' v-if="this.IzbranaNaloga === 'Ruta' || this.IzbranaNaloga === 'Prelet'">za to vrsto
          leta morate <strong>OBVEZNO</strong> oddati nalog za let!
        </div>
      </div>
    </div>

    <div class="col-12">
      <!-- KRAJ VZLETA -->
      <div class="container">
        <label class="label-dropdown" for="namen">{{ $t('labelsM.vzlet') }}
          <button v-if="krajVzleta !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="krajVzleta = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenVzlet()">
          <i v-show="!dVzlet" class="fas fa-chevron-right"></i>
          <i v-show="dVzlet" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajVzleta" @click.prevent="OpenVzlet">
          {{ krajVzleta }}
        </button>
        <transition name="fade">
          <drop-down @vzlet="selectVzlet" :data="Letalisca" type="vzlet" @novoLetalisce="DodajLetalisce"
                     class="drop-down-btn" v-if="dVzlet"/>
        </transition>
      </div>
    </div>

    <div class="col-12">
      <!-- KRAJ PRISTANKA -->
      <div class="container">
        <label class="label-dropdown" for="krajPristanka">{{ $t('labelsM.pristanek') }}
          <button v-if="krajPristanka !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="krajPristanka = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenPristanek()">
          <i v-show="!dPristanek" class="fas fa-chevron-right"></i>
          <i v-show="dPristanek" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajPristanka" @click.prevent="OpenPristanek">
          {{ krajPristanka }}
        </button>
        <transition name="fade">
          <drop-down @pristanek="selectPristanek" :data="Letalisca" type="pristanek" @novoLetalisce="DodajLetalisce"
                     class="drop-down-btn" v-if="dPristanek"/>
        </transition>
      </div>
    </div>
    <!-- BLOCK ON/OFF -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: poletanje.length > 0 }" class="label-time p-2" for="poletanje">Block off:</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Poletanje" id="poletanje"
               v-model="poletanje" required/>
      </div>
    </div>
    <!-- TAKE OFF -->
    <div class="col-12" v-if="flightTime">
      <div class="container">
        <label :class="{ hidden: takeoff.length > 0 }" class="label-time p-2" for="takeoff">Take off:</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="time" id="takeoff" v-model="takeoff"/>
      </div>
    </div>
    <div class="col-12" v-if="IzbranaNaloga !== 'Šolski krog'">
      <div class='container'>
        <label class="label-choose" for="vlecno">{{ $t('labelsM.nezakljucen') }}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input @change="SpremeniPodatke()" class="input-radio" type="checkbox" value="true" v-model="nezakljucen"/>
        </div>
      </div>
    </div>
    <!-- LANDING -->
    <div class="col-12" v-if="nezakljucen === false && flightTime">
      <div class="container">
        <label :class="{ hidden: landing.length > 0 }" class="label-time p-2" for="landing">Landing:</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="time" id="landing" v-model="landing"/>
      </div>
    </div>
    <div class="col-12" v-if="nezakljucen === false">
      <div class="container">
        <label :class="{ hidden: pristanek.length > 0 }" class="label-time p-2" for="pristanek">Block on:</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Pristanek" id="pristanek"
               v-model="pristanek" required/>
      </div>
    </div>
    <!-- ST PRISTANKOV -->
    <div class="col-12" v-if="nezakljucen === false">
      <div class="container">
        <label :class="{ hidden: stPristankov.length > 0 }" class="label-time p-2"
               for="casUgasanja">{{ $t('labelsM.stPristankov') }}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="stPristankov" v-model="stPristankov"
               required/>
      </div>
    </div>
    <!--    <div class="col-12" v-if="nezakljucen === false">-->
    <!--      <div class='container'>-->
    <!--        <label class="label-choose" for="vnosTrajanja">{{$t('labelsM.vnosTrajanja')}}</label>-->
    <!--        <div class="input border-0 rounded-4 p-2 fs-5">-->
    <!--          <input class="input-radio" type="checkbox" value="true" v-model="vnosTrajanja" />-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    &lt;!&ndash; V ZRAKU &ndash;&gt;-->
    <!--    <div class="col-12" v-if="nezakljucen === false && vnosTrajanja">-->
    <!--      <div class="container">-->
    <!--        <label :class="{ hidden: v_zraku.length > 0 }" class="label-time p-2" for="v_zraku">{{$t('labelsM.v_zraku')}}</label>-->
    <!--        <input class="input border-0 rounded-4 p-2 fs-5" type="time" id="v_zraku" v-model="v_zraku" placeholder="hh:mm" />-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- OPOMBA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: opomba.length > 0 }" class="label" for="opomba">{{ $t('labelsM.opomba') }}</label>
        <textarea class="input-comment border-0 rounded-4 p-2 fs-5" type="textarea" id="opomba" v-model="opomba"
                  rows="6" autocomplete="off">
                    </textarea>
      </div>
    </div>
    <!-- OPOZORILO -->
    <div class='col-12'>
      <div class='container'>
        <div class="label-date p-2 col-12">*{{ $t('labelsM.opozorilo') }}</div>
      </div>
    </div>
    <div class="container p-2">
      <button @click.prevent="Add()" class="btn btn-primary rounded-pill btn-add col-12"
              data-umami-event="Motorna-dodajanje-leta" :disabled="vnasam">{{ $t('buttons.vnesiZapis') }} <i
          class="fas fa-spinner fa-spin" v-if="vnasam"></i></button>
    </div>

    <!-- DODAJ LETALIŠČE MODAL -->
    <div class="modal modal-kartica" ref="modalDodajanjaLetalisca" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="ZapriModal">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <!-- Navigation Tabs -->
          <div class='modal-header justify-content-between'>
            <h5 class="card-title"><i class="fas fa-plane fa-lg"></i> {{ $t('labelsM.dodajLetalisce') }}</h5>
          </div>
          <div class="modal-body col-12">
            <div class="container">
              <label :class="{ hidden: imeUpper.length > 0 }" class="label-time p-2"
                     for="novIcao">{{ $t('labelsM.novIcao') }}</label>
              <input class="input border-0 rounded-4 p-2 fs-5" type="text" maxlength="30" id="novIcao"
                     v-model="imeUpper"/>
              <div class='text-center text-success mt-2' v-if="letalisceDodano">
                <span class='text-white'>{{ imeDodanegaLetalisca }}</span><br/>
                <i class="fas fa-check text-success text-center mt-2"></i> {{ $t('obvestila.zapisDodan') }}
              </div>
            </div>
            <div class="container p-2 mt-2">
              <button @click.prevent="PreveriIcao()" class="btn btn-primary rounded-pill btn-add col-12"
                      :disabled="this.dodajanjeLetalisca" data-umami-event="Motorna-dodajanje-leta"><i
                  class="fas fa-plus"></i> {{ $t('buttons.dodajLetalisce') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
  </div>
</template>